import {hapticFeedback} from "@tma.js/sdk-vue";
import {useToast} from "vue-toast-notification";
import {useI18n} from "vue-i18n";
import isInTelegram from "@/utils/isInTelegram";

export function useCode() {
	const toast = useToast();
	const {t} = useI18n();

	const share = async (data: ShareData) => {
		try {
			await navigator.share(data);
		} catch (err) {
			console.error('Failed to share: ', err);
		}
	};

	const copy = async (text: string) => {
		try {
			await navigator.clipboard.writeText(text);
			console.log('Content copied to clipboard');
		} catch (err) {
			console.error('Failed to copy: ', err);
		}
	};

	const copyToClipboard = async (value: string) => {
		if (isInTelegram() && hapticFeedback.impactOccurred.isAvailable()) {
			hapticFeedback.impactOccurred('medium');
		}
		copy(value).then(() => {
			toast.info(t('common.toast.copied_to_clipboard'), {
				position: 'top'
			});
		});
	}

	return {
		share,
		copy,
		copyToClipboard
	};
}
